import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { NotificationType } from './notificationTypes';
import NotificationContextType from './NotificationContextType';
import { NotificationsIcons, NotificationsIconClass } from './NotificationsColors';
import { NotificationBase } from './notificationBase';
import { v4 as uuidv4 } from 'uuid'; // Import uuid correctly
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotifications = () => {
  const context = React.useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {  
  const [notifications, setNotificationsContext] = useState<NotificationBase[]>([]);
  const { t } = useTranslation(); // Use the translation hook here

  const removeNotification = useCallback((id: string) => {
    setNotificationsContext(currentNotifications =>
      currentNotifications.filter(notification => notification.id !== id)
    );
  }, []);

  const defaultTitle: string | null = null;

  const showNotification: NotificationContextType['showNotification'] = (
    notificationOrMessage: NotificationBase | string,
    type: NotificationType = NotificationType.Success,
    title: string | null = null
  ) => {
    let id = uuidv4(); // Generate unique ID for notifications

    if (typeof notificationOrMessage === 'string') {

      const notification: NotificationBase = {
        id,
        message: notificationOrMessage,
        type,
        title: title || ''
      };

      setNotificationsContext(prevNotifications => [...prevNotifications, notification]);
      setTimeout(() => removeNotification(id), 5000);
    } else {
      setNotificationsContext(prevNotifications => [...prevNotifications, notificationOrMessage]);
      setTimeout(() => removeNotification(notificationOrMessage.id), 5000);
    }
  };

  const setNotifications: NotificationContextType['setNotifications'] = (notifications?: NotificationBase[]) => {
    if (notifications) {
      notifications.map(notification => {
        showNotification(notification);
      });
    }
  };

  return (
    <NotificationContext.Provider value={{ showNotification, setNotifications }}>
      {children}
      <div className="fixed top-2 sm:top-5 right-2 sm:right-5 z-[9999] flex flex-col space-y-2 max-w-[95vw] sm:max-w-sm">
        {notifications.map(({ id, title, message, type }) => {
          const NotificationIcon = NotificationsIcons[type];
          const iconClass = NotificationsIconClass[type];
          return (
            <div key={id} className={`flex items-center bg-${iconClass}-100 border-${iconClass}-300 rounded-md shadow-lg p-2`}>
              <div className="flex-none">
                {NotificationIcon && <NotificationIcon className={`text-${iconClass}-500 w-6 h-6 m-2`} />}
              </div>
              <div className="flex-grow m-2 overflow-hidden text-center">
                {title && <h6 className={`text-sm font-bold text-${iconClass}-700 break-words`}>{t(title)}</h6>}
                <p className="text-xs break-words">{t(message)}</p>
              </div>
              <div className="flex-none">
                <button onClick={() => removeNotification(id)}>
                  <X />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </NotificationContext.Provider>
  );
};

export default NotificationContext;

// import React, { createContext, useState, useCallback, ReactNode } from 'react';
// import { NotificationType } from './notificationTypes';
// import Alert from '../Alert';
// import NotificationContextType from './NotificationContextType';
// import { NotificationsIcons, NotificationsIconClass } from './NotificationsColors';
// import { NotificationBase } from './notificationBase';
// import { uuid } from 'uuidv4';
// import { X } from 'lucide-react';

// const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

// export const useNotifications = () => {
//   const context = React.useContext(NotificationContext);
//   if (context === undefined) {
//     throw new Error('useNotification must be used within a NotificationProvider');
//   }
//   return context;
// };

// export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {  
//   const [notifications, setNotificationsContext] = useState<NotificationBase[]>([]);

//   const removeNotification = useCallback((id: string) => {
//     setNotificationsContext(currentNotifications => currentNotifications.filter(notification => notification.id !== id));
//   }, []);

//   const defaultTitle: string | null = null;

//   const showNotification: NotificationContextType["showNotification"] = (notificationOrmessage: NotificationBase | string, type?: NotificationType, title?: string | null) => {
//     console.log("showNotificaion");
//     if (typeof notificationOrmessage === 'string') {
//       let id = uuid();
//       console.log(id);
//       const notification: NotificationBase = { id: id, message: notificationOrmessage, type: type || NotificationType.Success, title: title || '' };
//       setNotificationsContext(prevNotifications => [...prevNotifications, notification]);
//       setTimeout(() => removeNotification(id), 5000);
//     } else {
//       setNotificationsContext(prevNotifications => [...prevNotifications, notificationOrmessage]);      
//       setTimeout(() => removeNotification(notificationOrmessage.id), 5000);
//     }
//   };

//   const setNotifications: NotificationContextType["setNotifications"] = (notifications?: NotificationBase[]) => {
//     console.log("setNotification")
//     if (notifications) {
//       notifications.map((notification) => {
//         showNotification(notification);
//       });
//     }
//   }

//   return (
//     <NotificationContext.Provider value={{ showNotification, setNotifications }}>
//       {children}
//       <div className="fixed top-2 sm:top-5 right-2 sm:right-5 z-[9999] flex flex-col space-y-2 max-w-[95vw] sm:max-w-sm">
//         {notifications.map(({ id, title, message, type }) => {
//           const NotificationIcon = NotificationsIcons[type];
//           const iconClass = NotificationsIconClass[type];
//           return (
//             <div key={id} className={`flex items-center bg-${iconClass}-100 border-${iconClass}-300 rounded-md shadow-lg p-2`}>
//               <div className="flex-none">
//                 {NotificationIcon && <NotificationIcon className={`text-${iconClass}-500 w-6 h-6 m-2`} />}
//               </div>
//               <div className="flex-grow m-2 overflow-hidden text-center">
//                 {title && <h6 className={`text-sm font-bold text-${iconClass}-700 break-words`}>{title}</h6>}
//                 <p className="text-xs break-words">{message}</p>
//               </div>
//               <div className="flex-none">
//                 <button onClick={() => removeNotification(id)}>
//                   <X />
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </NotificationContext.Provider>
//   );
// };

// export default NotificationContext;
